if (typeof SidebarDrawer !== 'function') {

	class SidebarDrawer extends HTMLElement {

		constructor(){
			super();
    			this.siteOverlay = document.getElementById('site-overlay');
    			this.querySelector('.site-close-handle').addEventListener('click', ()=>{
              this.hide();
			});
		}

		show(){
			this.style.display = 'block';
			setTimeout(()=>{
				this.classList.add('active');
				// window.inertElems.forEach(elm=>{
				// 	elm.setAttribute('inert', '');
				// });
			}, 10);
			// this.siteOverlay.classList.add('active');
			document.body.classList.add('sidebar-move');
			document.querySelector('html').classList.add('kill-overflow');
			this.style.height = `${window.innerHeight}px`;
			if ( this.id == "site-cart" ) {
				if ( document.querySelector('#cart-recommendations css-slider') ) {
					document.querySelector('#cart-recommendations css-slider').resetSlider();
				}
			}
		}

		hide(){
			this.classList.remove('active');
			// this.siteOverlay.classList.remove('active');
			document.body.classList.remove('sidebar-move');
			document.querySelector('html').classList.remove('kill-overflow');
			document.querySelector('body').classList.remove('drawer-menu-opened');
			// window.inertElems.forEach(elm=>{
			// 	elm.removeAttribute('inert');
			// })
			setTimeout(()=>{
				this.style.display = 'none';
			}, 250);
		}

	}


  if (typeof customElements.get('sidebar-drawer') == 'undefined') {
		customElements.define('sidebar-drawer', SidebarDrawer);
	}

}

document.addEventListener('DOMContentLoaded', function() {
  const mobileNav = document.getElementById('site-nav--mobile');
  const menuHandles = document.querySelectorAll('.site-burger-handle');
  const closeHandles = document.querySelectorAll('.site-close-handle');

  menuHandles.forEach(handle => {
    handle.addEventListener('click', function() {
      if (mobileNav.classList.contains('active')) {
        mobileNav.hide();
      } else {
        mobileNav.show();
      }
    });
  });
  closeHandles.forEach(handle => {
    handle.addEventListener('click', function() {
      mobileNav.hide();
    });
  });

  function waitForGsap(cb) {
    if (window.gsap) { cb(); return; }
    var t = setInterval(function() {
      if (window.gsap) { clearInterval(t); cb(); }
    }, 50);
  }

  waitForGsap(function() {
    var DURATION  = 0.4;
    var EASE_OPEN = 'power2.out';
    var EASE_SHUT = 'power2.in';

    function closeItem(item) {
      if (item.getAttribute('aria-expanded') !== 'true') return;
      var menu  = item.querySelector('.babymenu');
      var caret = item.querySelector('.icon-caret');
      gsap.to(menu, { height: 0, duration: DURATION, ease: EASE_SHUT,
        onComplete: function() { item.setAttribute('aria-expanded', 'false'); }
      });
      if (caret) gsap.to(caret, { rotation: 0, duration: DURATION, ease: EASE_SHUT });
    }

    function openItem(item) {
      var menu  = item.querySelector('.babymenu');
      var caret = item.querySelector('.icon-caret');
      item.setAttribute('aria-expanded', 'true');
      var targetH = menu.scrollHeight;
      gsap.fromTo(menu, { height: 0 },
        { height: targetH, duration: DURATION, ease: EASE_OPEN,
          onComplete: function() { gsap.set(menu, { height: 'auto' }); }
        }
      );
      if (caret) gsap.to(caret, { rotation: 180, duration: DURATION, ease: EASE_OPEN });
    }

    var allItems = document.querySelectorAll('#site-nav--mobile .mega-link[aria-controls]');

    allItems.forEach(function(item) {
      var childLink = item.querySelector('.child-link');
      if (!childLink) return;

      // Initialise: ensure babymenu starts collapsed
      var menu = item.querySelector('.babymenu');
      if (menu) { gsap.set(menu, { height: 0, overflow: 'hidden' }); }

      childLink.addEventListener('click', function(e) {
        e.preventDefault();
        var isOpen = item.getAttribute('aria-expanded') === 'true';

        // Close all siblings first
        allItems.forEach(function(sibling) {
          if (sibling !== item) closeItem(sibling);
        });

        if (isOpen) {
          closeItem(item);
        } else {
          openItem(item);
        }
      });
    });
  });
});
